module.exports = __webpack_public_path__ + "df34542a4b519c53e48292e9f2bc924b.svg";